import React from 'react';
import { BodyMBold, BodyM, HeadingSBold, HeadingS } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/servicesTabStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleLineProps {
	title: string;
	subtitle?: string;
	value: string | number;
	bold?: boolean;
}

const SingleLine = ({ title, subtitle, value, bold }: ISingleLineProps) => {
	const classes = useStyles();

	return (
		<div className={classes.singleLine}>
			<ConditionalRender
				show={!!bold}
				onTrue={() => (
					<div>
						<HeadingS disableMargin color="primary-light">
							{title}
						</HeadingS>
						<HeadingS disableMargin color="secondary-light">
							{subtitle}
						</HeadingS>
					</div>
				)}
				onFalse={() => (
					<div>
						<BodyM disableMargin color="primary-light">
							{title}
						</BodyM>
						<BodyM disableMargin color="secondary-light">
							{subtitle}
						</BodyM>
					</div>
				)}
			/>
			<ConditionalRender
				show={!!bold}
				onTrue={() => (
					<HeadingSBold disableMargin color="primary-light">
						{String(value)}
					</HeadingSBold>
				)}
				onFalse={() => (
					<BodyMBold disableMargin color="primary-light">
						{String(value)}
					</BodyMBold>
				)}
			/>
		</div>
	);
};

export default SingleLine;
